module.exports = __webpack_public_path__ + "static/curate-products-tablet-49521c1b09d03161608d83f8e5f01ed6.png";